import { Typography } from 'antd';
import * as React from 'react';
import { IInputLikeWrapperProps, InputLikeWrapper } from './InputLikeWrapper';

export interface IInputLikeTextProps
  extends Omit<IInputLikeWrapperProps, 'children'> {
  text?: React.ReactNode;
}

export function InputLikeText(props: IInputLikeTextProps) {
  const { text, ...otherProps } = props;
  return (
    <InputLikeWrapper {...otherProps}>
      <Typography.Text ellipsis>{text}</Typography.Text>
    </InputLikeWrapper>
  );
}
